module.exports = __webpack_public_path__ + "img/icon_j1.d923c2e.png";